import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getExcelFormData2,
  getPercentageRecheck,
  updateForm2,
} from "../../api";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateConfig , getCVDCompletedRecheckList,
  getCVDPendingRecheckList,
  getCVDMarkedRecheckList,
  getCVDRejectedRecheckList, } from "../../../../../store/slices/CVD/CVDSlice";

const useVersionTwo2 = () => {
  const {
    item,
    excelEditedFormData,
    data,
    activeId,
    certificateID,
    excelFormData,
    itemID,
    certificateNumber,
    assignedID
  } = useSelector((state) => state.cvd);
  const slug = sessionStorage?.getItem("slug");
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = useState("");
  useEffect(() => {
    handleReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId]);

  const currentTab = data?.filter(
    (value) => value?.name === `Version ${activeId}`
  );

  const isFlatGradedData = Array.isArray(excelFormData?.updated_values) && excelFormData.updated_values.length > 0
  ? excelFormData.updated_values.some(item => 'rft_diamond_number' in item)
  : excelFormData?.graded_values?.rft_diamond_number ? true : (
      excelFormData?.graded_values &&
      Object.values(excelFormData.graded_values).every(
        value => typeof value !== 'object' || value === null 
      )
    )

  const forms =
    excelEditedFormData?.length > 0
      ? excelEditedFormData?.[
          !currentTab?.[0]?.disabled
            ? excelEditedFormData?.length - 1
            : activeId - 2
        ]
      : excelEditedFormData;

  const handleReset = () => {
    const newValues = {
      status2:
        (forms?.cvd_status
          ? forms?.cvd_status
          : excelFormData?.process?.status) || "",
      remark:
        (forms?.cvd_remark ? forms?.cvd_remark : excelFormData?.remarks) || "",

      cvd_weight: forms?.cvd?.weight || "",
      cvd_d_no: forms?.cvd?.diamond_number || "",
      cvd_percentage: forms?.cvd?.percentage || "",

      cvd_pass_weight: forms?.cvd_pass?.weight || "",
      cvd_pass_d_no: forms?.cvd_pass?.diamond_number || "",
      cvd_pass_percentage: forms?.cvd_pass?.percentage || "",

      htpt_weight: forms?.hpht?.weight || "",
      htpt_d_no: forms?.hpht?.diamond_number || "",
      htpt_percentage: forms?.hpht?.percentage || "",

      rft_weight: forms?.rft?.weight || "",
      rft_d_no: forms?.rft?.diamond_number || "",
      rft_percentage: forms?.rft?.percentage || "",

      rft_diamond_number: forms?.rft_diamond_number || "",
      percentage: forms?.percentage || "",
      image: forms?.image || "",
    };
    setImagePreview("");
    formik.setValues(newValues);
  };
  const formik = useFormik({
    initialValues: {
      status2:
        (forms?.cvd_status
          ? forms?.cvd_status
          : excelFormData?.process?.status) || "",
      remark:
        (forms?.cvd_remark ? forms?.cvd_remark : excelFormData?.remarks) || "",
      cvd_weight: forms?.cvd?.weight || "",
      cvd_d_no: forms?.cvd?.diamond_number || "",
      cvd_percentage: forms?.cvd?.percentage || "",

      cvd_pass_weight: forms?.cvd_pass?.weight || "",
      cvd_pass_d_no: forms?.cvd_pass?.diamond_number || "",
      cvd_pass_percentage: forms?.cvd_pass?.percentage || "",

      htpt_weight: forms?.hpht?.weight || "",
      htpt_d_no: forms?.hpht?.diamond_number || "",
      htpt_percentage: forms?.hpht?.percentage || "",

      rft_weight: forms?.rft?.weight || "",
      rft_d_no: forms?.rft?.diamond_number || "",
      rft_percentage: forms?.rft?.percentage || "",

      rft_diamond_number: forms?.rft_diamond_number || "",
      percentage: forms?.percentage || "",
      image: forms?.image || "",
    },

    validate: (values) => {
      const errors = {};
      if (!values?.status2) {
        errors.status2 = "Select Status";
      }
      if (!isFlatGradedData) {
        let isAnySectionCompleted = false;
        if (values.rft_weight && values.rft_d_no && values.rft_percentage) {
          isAnySectionCompleted = true;
        }
        if (values.cvd_weight && values.cvd_d_no && values.cvd_percentage) {
          isAnySectionCompleted = true;
        }
        if (values.htpt_weight && values.htpt_d_no && values.htpt_percentage) {
          isAnySectionCompleted = true;
        }
        if (
          values.cvd_pass_weight &&
          values.cvd_pass_d_no &&
          values.cvd_pass_percentage
        ) {
          isAnySectionCompleted = true;
        }

        if (!values.rft_weight && !values.rft_d_no && !values.rft_percentage) {
          errors.rft_weight = "Enter a valid number";
          errors.rft_d_no = "Enter valid number";
          errors.rft_percentage = "Enter a valid percentage";
        }
        if (!values.cvd_weight && !values.cvd_d_no && !values.cvd_percentage) {
          errors.cvd_weight = "Enter a valid number";
          errors.cvd_d_no = "Enter valid number";
          errors.cvd_percentage = "Enter a valid percentage";
        }
        if (
          !values.htpt_weight &&
          !values.htpt_d_no &&
          !values.htpt_percentage
        ) {
          errors.htpt_weight = "Enter a valid number";
          errors.htpt_d_no = "Enter valid number";
          errors.htpt_percentage = "Enter a valid percentage";
        }
        if (
          !values.cvd_pass_weight &&
          !values.cvd_pass_d_no &&
          !values.cvd_pass_percentage
        ) {
          errors.cvd_pass_weight = "Enter a valid number";
          errors.cvd_pass_d_no = "Enter valid number";
          errors.cvd_pass_percentage = "Enter a valid percentage";
        }
        // Validation for rft
        if (values.rft_weight || values.rft_d_no || values.rft_percentage) {
          if (
            !values.rft_weight ||
            !/^(?:\d*\.)?\d+$/.test(values.rft_weight)
          ) {
            errors.rft_weight = "Enter a valid number";
          }
          if (!values.rft_d_no || !/^[0-9]*$/.test(values.rft_d_no)) {
            errors.rft_d_no = "Enter valid number";
          }
          if (!values.rft_percentage) {
            errors.rft_percentage = "This field is required";
          } else if (!/^\d+(\.\d{1,2})?$/.test(values.rft_percentage)) {
            errors.rft_percentage = "Enter a valid percentage";
          } else {
            const numericValue = parseFloat(values.rft_percentage);
            if (numericValue > 100) {
              errors.rft_percentage = "Enter a valid percentage";
            }
          }
        }

        // Validation for cvd
        if (values.cvd_weight || values.cvd_d_no || values.cvd_percentage) {
          if (
            !values.cvd_weight ||
            !/^(?:\d*\.)?\d+$/.test(values.cvd_weight)
          ) {
            errors.cvd_weight = "Enter a valid number";
          }
          if (!values.cvd_d_no || !/^[0-9]*$/.test(values.cvd_d_no)) {
            errors.cvd_d_no = "Enter valid number";
          }
          if (!values.cvd_percentage) {
            errors.cvd_percentage = "This field is required";
          } else if (!/^\d+(\.\d{1,2})?$/.test(values.cvd_percentage)) {
            errors.cvd_percentage = "Enter a valid percentage";
          } else {
            const numericValue = parseFloat(values.cvd_percentage);
            if (numericValue > 100) {
              errors.cvd_percentage = "Enter a valid percentage";
            }
          }
        }

        // Validation for hpht
        if (values.htpt_weight || values.htpt_d_no || values.htpt_percentage) {
          if (
            !values.htpt_weight ||
            !/^(?:\d*\.)?\d+$/.test(values.htpt_weight)
          ) {
            errors.htpt_weight = "Enter a valid number";
          }
          if (!values.htpt_d_no || !/^[0-9]*$/.test(values.htpt_d_no)) {
            errors.htpt_d_no = "Enter valid number";
          }
          if (!values.htpt_percentage) {
            errors.htpt_percentage = "This field is required";
          } else if (!/^\d+(\.\d{1,2})?$/.test(values.htpt_percentage)) {
            errors.htpt_percentage = "Enter a valid percentage";
          } else {
            const numericValue = parseFloat(values.htpt_percentage);
            if (numericValue > 100) {
              errors.htpt_percentage = "Enter a valid percentage";
            }
          }
        }

        // Validation for cvd_pass
        if (
          values.cvd_pass_weight ||
          values.cvd_pass_d_no ||
          values.cvd_pass_percentage
        ) {
          if (
            !values.cvd_pass_weight ||
            !/^(?:\d*\.)?\d+$/.test(values.cvd_pass_weight)
          ) {
            errors.cvd_pass_weight = "Enter valid number";
          }
          if (!values.cvd_pass_d_no || !/^[0-9]*$/.test(values.cvd_pass_d_no)) {
            errors.cvd_pass_d_no = "Enter valid number";
          }
          if (!values.cvd_pass_percentage) {
            errors.cvd_pass_percentage = "This field is required";
          } else if (!/^\d+(\.\d{1,2})?$/.test(values.cvd_pass_percentage)) {
            errors.cvd_pass_percentage = "Enter a valid percentage";
          } else {
            const numericValue = parseFloat(values.cvd_pass_percentage);
            if (numericValue > 100) {
              errors.cvd_pass_percentage = "Enter a valid percentage";
            }
          }
        }
        // If at least one section is completed, clear errors for other sections
        if (isAnySectionCompleted) {
          clearSectionErrors(errors, "rft");
          clearSectionErrors(errors, "cvd");
          clearSectionErrors(errors, "htpt");
          clearSectionErrors(errors, "cvd_pass");
        }
      } else {
        if (
          isFlatGradedData &&
          values?.status2 !== 2 &&
          values?.status2?.id !== 2 &&
          values?.status2 !== ""
        ) {
          if (
            !values.rft_diamond_number ||
            !/^[0-9]*$/.test(values.rft_diamond_number)
          ) {
            errors.rft_diamond_number = "Enter valid number";
          }

          if (!values.percentage) {
            errors.percentage = "This field is required";
          }

          // if (!values.image) {
          //   errors.image = "Add one image";
          // } else {
          //   // Validate image file type
          //   const acceptedFormats = ["image/jpeg", "image/png"];
          //   if (!acceptedFormats.includes(values.image.type)) {
          //     errors.image = "Only JPEG and PNG formats are allowed";
          //   }

          //   // Validate image file size
          //   const maxSizeInBytes = 2 * 1024 * 1024;
          //   if (values.image.size > maxSizeInBytes) {
          //     errors.image = "File size must be less than 2 MB";
          //   } else {
          //     // Clear all errors when status is "2"
          //     Object.keys(errors).forEach((key) => {
          //       if (key === "status") {
          //         errors[key] = "Select Status";
          //       } else {
          //         errors[key] = undefined;
          //       }
          //     });
          //   }
          // }
        }
      }
      return errors;
    },

    enableReinitialize: true,
    onSubmit: (values) => {
      let formData = new FormData();
      if (!isFlatGradedData) {
        formData.append("recheck_item_details_id", certificateID);
        formData.append("status", values?.status2?.id ?? values?.status2);
        formData.append("remarks", values?.remark);
        formData.append("cvd[weight]", values?.cvd_weight);
        formData.append("cvd[diamond_number]", values?.cvd_d_no);
        formData.append("cvd[percentage]", values?.cvd_percentage);
        formData.append("cvd_pass[weight]", values?.cvd_pass_weight);
        formData.append("cvd_pass[diamond_number]", values?.cvd_pass_d_no);
        formData.append("cvd_pass[percentage]", values?.cvd_pass_percentage);
        formData.append("hpht[weight]", values?.htpt_weight);
        formData.append("hpht[diamond_number]", values?.htpt_d_no);
        formData.append("hpht[percentage]", values?.htpt_percentage);
        formData.append("rft[weight]", values?.rft_weight);
        formData.append("rft[diamond_number]", values?.rft_d_no);
        formData.append("rft[percentage]", values?.rft_percentage);
      } else {
        formData.append("recheck_item_details_id", certificateID);
        formData.append("status", values?.status2?.id ?? values?.status2);
        formData.append("remarks", values?.remark);
        formData.append("rft_diamond_number", values?.rft_diamond_number);
        formData.append("percentage", values?.percentage);
        if (values?.image instanceof File) {
          // It's a new upload
          formData.append("image", values.image);
        }
      }

      updateForm2(formData).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success("Data updated ");
          dispatch(
            updateConfig((state) => {
              state.certificateID = certificateID;
              state.itemID = item?.gli_number;
              state.showCompare = false;
            })
          );
          dispatch(
            updateConfig((state) => {
              state.cvdRecheckData.Pending = [];
              state.cvdRecheckData.Passed = [];
              state.cvdRecheckData.Rejected = [];
              state.cvdRecheckData.Marked = [];
            })
          );
              dispatch(
                     getCVDPendingRecheckList({
                       page: 1,
                       per_page: 10,
                       receipt_id: assignedID,
                       process_slug: slug,
                     })
                   );
                   dispatch(
                     getCVDCompletedRecheckList({
                       page: 1,
                       per_page: 10,
                       receipt_id: assignedID,
                       process_slug: slug,
                     })
                   );
                   dispatch(
                     getCVDMarkedRecheckList({
                       page: 1,
                       per_page: 10,
                       receipt_id: assignedID,
                       process_slug: slug,
                       status: 5,
                     })
                   );
                   dispatch(
                     getCVDRejectedRecheckList({
                       page: 1,
                       per_page: 10,
                       receipt_id: assignedID,
                       process_slug: slug,
                       status: 4,
                     })
                   );
          let data = {
            item_details_id: item?._id,
            // item_type_id: item?.item_type_id,
            // process_slug: slug,
          };
          getExcelFormData2(certificateID)
            .then((response) => {
              if (response?.data?.status_code === 200) {
                if (response?.data?.data?.updated_values.length !== 0) {
                  const newData = response.data.data.updated_values?.map(
                    (_, index) => ({
                      name: `Version ${index + 2}`,
                    })
                  );
                  dispatch(
                    updateConfig((state) => {
                      state.data = [{ name: "Version 1" }, ...newData]?.map(
                        (version) => ({
                          ...version,
                          disabled: true, // Set the 'disabled' property to true for all versions
                        })
                      );
                    })
                  );
                }
                dispatch(
                  updateConfig((state) => {
                    state.excelFormData = response?.data?.data;
                    state.excelEditedFormData =
                      response?.data?.data?.updated_values.length === 0
                        ? (state.excelFormData =
                            response?.data?.data?.graded_values)
                        : response?.data?.data?.updated_values;
                    state.showValues = true;
                    state.showForm = false;
                  })
                );
              }
            })
            .catch((error) => toast.error(error));
        } else if (response?.status_code === 422) {
          const errors = response.errors;
          formik.setErrors(errors);
        } else {
          toast.error("Something went wrong");
        }
      });
    },
  });
  useEffect(() => {
    if (forms) {
      formik.setValues({
        status2:
          (forms?.cvd_status
            ? forms?.cvd_status
            : excelFormData?.process?.status) || "",
        remark:
          (forms?.cvd_remark ? forms?.cvd_remark : excelFormData?.remarks) ||
          "",
        cvd_weight: forms?.cvd?.weight || "",
        cvd_d_no: forms?.cvd?.diamond_number || "",
        cvd_percentage: forms?.cvd?.percentage || "",

        cvd_pass_weight: forms?.cvd_pass?.weight || "",
        cvd_pass_d_no: forms?.cvd_pass?.diamond_number || "",
        cvd_pass_percentage: forms?.cvd_pass?.percentage || "",

        htpt_weight: forms?.hpht?.weight || "",
        htpt_d_no: forms?.hpht?.diamond_number || "",
        htpt_percentage: forms?.hpht?.percentage || "",

        rft_weight: forms?.rft?.weight || "",
        rft_d_no: forms?.rft?.diamond_number || "",
        rft_percentage: forms?.rft?.percentage || "",

        rft_diamond_number: forms?.rft_diamond_number || "",
        percentage: forms?.percentage || "",
        image: forms?.image || "",
      });
    }
  }, [forms]);

  // Helper function to clear errors for a section
  function clearSectionErrors(errors, section) {
    delete errors[`${section}_weight`];
    delete errors[`${section}_d_no`];
    delete errors[`${section}_percentage`];
  }

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const handleRFTDNOChange = (e) => {
    let value = e?.target?.value;
    formik?.setFieldValue("rft_d_no", value);
    let data = {
      id: certificateID,
      d_no: value,
      slug,
    };
    getPercentageRecheck(data)
      .then((response) => {
        if (response?.data?.status_code === 200) {
          formik?.setFieldValue(
            "rft_percentage",
            response?.data?.data?.percentage
          );
        } else if (response?.status_code === 403) {
          toast.error(response?.message ?? "Can't fetch percentage");
        } else {
          toast.error("Can't fetch percentage");
        }
      })
      .catch(() => {
        toast.error("Can't fetch percentage");
      });
  };
  const handleCVDDNOChange = (e) => {
    let value = e?.target?.value;
    formik?.setFieldValue("cvd_d_no", value);
    let data = {
      id: certificateID,
      d_no: value,
      slug,
    };
    getPercentageRecheck(data)
      .then((response) => {
        if (response?.data?.status_code === 200) {
          formik?.setFieldValue(
            "cvd_percentage",
            response?.data?.data?.percentage
          );
        } else if (response?.status_code === 403) {
          toast.error(response?.message ?? "Can't fetch percentage");
        } else {
          toast.error("Can't fetch percentage");
        }
      })
      .catch(() => {
        toast.error("Can't fetch percentage");
      });
  };
  const handleCVDPassDNOChange = (e) => {
    let value = e?.target?.value;
    formik?.setFieldValue("cvd_pass_d_no", value);
    let data = {
      id: certificateID,
      d_no: value,
      slug,
    };
    getPercentageRecheck(data)
      .then((response) => {
        if (response?.data?.status_code === 200) {
          formik?.setFieldValue(
            "cvd_pass_percentage",
            response?.data?.data?.percentage
          );
        } else if (response?.status_code === 403) {
          toast.error(response?.message ?? "Can't fetch percentage");
        } else {
          toast.error("Can't fetch percentage");
        }
      })
      .catch(() => {
        toast.error("Can't fetch percentage");
      });
  };
  const handleHTPTDNOChange = (e) => {
    let value = e?.target?.value;
    formik?.setFieldValue("htpt_d_no", value);
    let data = {
      id: certificateID,
      d_no: value,
      slug,
    };
    getPercentageRecheck(data)
      .then((response) => {
        if (response?.data?.status_code === 200) {
          formik?.setFieldValue(
            "htpt_percentage",
            response?.data?.data?.percentage
          );
        } else if (response?.status_code === 403) {
          toast.error(response?.message ?? "Can't fetch percentage");
        } else {
          toast.error("Can't fetch percentage");
        }
      })
      .catch(() => {
        toast.error("Can't fetch percentage");
      });
  };

  useEffect(() => {
    const rftNumber = formik?.values?.rft_diamond_number;
    const percentage = formik?.values?.percentage;

    if (!rftNumber) {
      formik?.setFieldValue("percentage", "");
      return;
    }

    // Avoid API call if percentage already exists (optional)
    if (percentage) return;

    const params = {
      id: certificateID,
      d_no: rftNumber,
      slug: slug,
    };

    const timeout = setTimeout(() => {
      getPercentageRecheck(params)
        .then((response) => {
          if (response?.data?.status_code === 200) {
            formik?.setFieldValue(
              "percentage",
              response?.data?.data?.percentage
            );
          } else {
            toast.error("Can't fetch percentage");
          }
        })
        .catch(() => {
          toast.error("Can't fetch percentage");
        });
    }, 500); // optional debounce delay

    return () => clearTimeout(timeout);
  }, [formik?.values?.rft_diamond_number, certificateID, slug]);

  const handleImageChange = (event) => {
    const image = event?.target?.files[0];
    formik.setFieldValue("image", image);
    const file = image;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return {
    formik,
    excelFormData,
    itemID,
    certificateNumber,
    currentTab,
    getFieldError,
    handleReset,
    handleCVDPassDNOChange,
    handleRFTDNOChange,
    handleCVDDNOChange,
    handleHTPTDNOChange,
    isFlatGradedData,
    handleImageChange,
    imagePreview,
  };
};

export default useVersionTwo2;
